import type { ReactNode } from 'react'
import logo from '../assets/defenssive-logo.png'
import { FlowStepper } from './FlowStepper'
import './flowStyles'

/**
 * The frame around the screens after the sign-in form: the link landing, Microsoft sign-in completion,
 * connect and consent review. A brand row and the four-step stepper above whatever the screen already
 * renders; the screens themselves are unchanged and are restyled by .flow-scope rules.
 *
 * `step` is the index the person is at (0 Account, 1 Connect). `wide` is for the connect screen, whose
 * two columns of "what it reads" / "what it does not" need more than a sign-in column.
 *
 * Wrapped at the route (App.tsx), not inside each screen, so the screens' own tests and logic are
 * untouched and the frame cannot change what any of them does.
 */
export function FlowFrame({ step, wide = false, children }: { step: number; wide?: boolean; children: ReactNode }) {
  return (
    <div className="flow-frame">
      <div className={wide ? 'flow-frame-inner is-wide flow-scope' : 'flow-frame-inner flow-scope'}>
        <header className="flow-brand">
          <img className="flow-brand-logo" src={logo} alt="" width={36} height={36} />
          <span className="flow-brand-name">Defenssive</span>
        </header>
        <FlowStepper at={step} />
        {children}
      </div>
    </div>
  )
}
